import { newDate } from "helpers/dateTools";

export const initialValues = {
    station: '',
    creLicense: '',
    number: '',
    capacity: '',
    serialNumber: '',
    description: '',
    brand: '',
    uuidAws: '',
    deviceId: '',
    expirationDate: newDate()
}

export const requiredValues = {
    station: { required: true },
    creLicense: { required: true },
    number: { required: true },
    capacity: { required: true },
    serialNumber: { required: true },
    description: { required: true },
    brand: { required: true },
    expirationDate: { required: true}
}